module.exports = __webpack_public_path__ + "assets/images/tela_riscos.20efb888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela_riscos.png
// module id = 662
// module chunks = 1